import { appRouterPaths } from "@/services/navigation";
import { DashboardsPage } from "@/pages/DashboardsPage";
import type { RouteProps } from "react-router-dom";

export const dashboardsPageRoute: RouteProps = {
  path: appRouterPaths.dashboards,
  element: <DashboardsPage />,
};
